import React from 'react'
import IFS_Logo from '../../data/img/ost_logo_de.png'

const Logo = () => {
  return (
    <a href="https://www.ost.ch/ifs" >
      <img src={IFS_Logo} alt="IFS Logo" className="logo" />
    </a>
  )
}

export default Logo
